import React, { useState } from 'react'
import Button from 'view/component/Button/Button'
import ModalContainer from '../ModalContainer/ModalContainer'
import { useDispatch, useSelector } from 'react-redux'
import BraydenCore from '@innosonian/brayden-core'
import { useTranslation } from 'react-i18next'
import Typography from 'view/component/Typography/Typography'
import { sagaPromise } from '@innosonian/brayden-core/build/src/_reducer/reducer'
import { hardDeleteUserClient } from '@innosonian/brayden-core/build/src/entity/UserClient/UserClient.saga'
import { toast } from 'react-toastify'

export default function ConfirmHardDeleteUserClient() {
    const { t } = useTranslation('locale')
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const selectedUserClientId = useSelector(
        BraydenCore.Entity.Modal.ModalSelector.getHardDeleteUserClientId
    )

    const deleteUser = async () => {
        setLoading(true)
        try {
            if (selectedUserClientId !== undefined) {
                await sagaPromise(hardDeleteUserClient, selectedUserClientId)
            }
            toast(t('ToastManager.DeleteUserClientSuccess'), {
                type: 'success',
            })
        } catch (e) {
            toast(t('ToastManager.DeleteUserClientError'), {
                type: 'error',
            })
        } finally {
            dispatch(
                BraydenCore.Entity.Modal.ModalAction.modalCloseHardDeleteUserClientConfirmation()
            )
            setLoading(false)
        }
    }

    return (
        <ModalContainer
            isOpen={selectedUserClientId !== undefined}
            closeButton={true}
            onCloseClick={() =>
                dispatch(
                    BraydenCore.Entity.Modal.ModalAction.modalCloseHardDeleteUserClientConfirmation()
                )
            }
        >
            <div className="flex flex-col h-full  w-full lg:px-10 justify-center items-center md:py-4">
                <div className="w-full pb-4">
                    <Typography>
                        {t('UserList.ConfirmHardDeleteUser')}
                    </Typography>
                </div>
                <div className="w-full flex flex-col">
                    <Typography>
                        {t('UserList.ConfirmHardDeleteUserContent')}
                    </Typography>
                </div>
                <div className="w-full flex justify-end">
                    <Button
                        disable={loading}
                        className="mr-2"
                        onclick={deleteUser}
                        type="plain"
                        shape="rounded-mid"
                        padding="sm"
                        color="secondary"
                    >
                        {t('UserList.Delete')}
                    </Button>
                </div>
            </div>
        </ModalContainer>
    )
}
